import { useEffect, useRef, useState } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";

interface AddMnRuleModalProps {
  panelLabel: string;
  onClose: () => void;
  onSave: (ruleText: string) => void;
}

const AddMnRuleModal = ({
  panelLabel,
  onClose,
  onSave,
}: AddMnRuleModalProps) => {
  const [ruleText, setRuleText] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    openModal(ModalId.ADD_MN_RULE_MODAL);
    setTimeout(() => textareaRef.current?.focus(), 100);
  }, []);

  const handleClose = () => {
    closeModal(ModalId.ADD_MN_RULE_MODAL);
    onClose();
  };

  const handleSave = () => {
    const trimmed = ruleText.trim();
    if (trimmed) {
      onSave(trimmed);
      handleClose();
    }
  };

  return (
    <Modal
      dialogId={ModalId.ADD_MN_RULE_MODAL}
      title={`Add ${panelLabel} Rule`}
      onSave={handleSave}
      onCancel={handleClose}
      onClose={handleClose}
      saveButtonText="Add Rule"
      cancelText="Cancel"
      disableSave={!ruleText.trim()}
    >
      <div className="flex flex-col gap-1">
        <label className="text-tiny font-medium text-primaryGray-1">
          Rule Text
        </label>
        <textarea
          ref={textareaRef}
          value={ruleText}
          onChange={(e) => setRuleText(e.target.value)}
          placeholder="Enter the rule text..."
          className="w-full resize-y rounded-lg border border-primaryGray-16 p-3 text-h12 outline-none focus:border-blue-500"
          rows={5}
        />
      </div>
    </Modal>
  );
};

export default AddMnRuleModal;
